import type { FeatureStyleNode } from '../feature-style.model';

export interface PhaseShiftParams {
  of: string;
}

export const PHASE_SHIFT_DEFAULT_PARAMS: Omit<PhaseShiftParams, 'of'> = {};

export const PHASE_SHIFT_DEFAULTS: FeatureStyleNode = {
  line: { color: 'green', strokeWidth: 2 },
  subparts: {
    referenceLine: { visible: true, line: { dash: 3 } },
    arrow: { visible: true, line: { dash: 0 } },
  },
};
